import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import JobsListing from '../../../components/jobs/JobsListing';
import { getUkBananaJobsByTitle } from '../../../services/HirecrapBanana';
import { capitalizeSlug } from '../../../services/DateFormats';

const UkJobsByTitle = () => {
  const { JobTitle } = useParams();
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);

  const capitalizedJobTitle = capitalizeSlug(JobTitle);
  const canonicalUrl = `https://www.fetchjobs.co/remote-jobs-uk/${JobTitle}`;

  useEffect(() => {
    setLoading(true);
    const fetchJobs = async () => {
      try {
        const data = await getUkBananaJobsByTitle(capitalizedJobTitle);
        setList(data.jobs);
      } catch (error) {
        console.log("Error fetching UK jobs by title:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, [capitalizedJobTitle]);

  return (
    <div>
      <JobsListing
        title={`Remote ${capitalizedJobTitle} Jobs in the UK`}
        subTitle={`Explore 100% remote ${capitalizedJobTitle} job opportunities in the UK. Apply now for top remote roles on FetchJobs!`}
        type="United Kingdom"
        searchKeyword={capitalizedJobTitle}
        suggestion={false}
        list={list}
        loading={loading}
        canonicalUrl={canonicalUrl}
        countryCode="GB"
        metaTitle={`Remote ${capitalizedJobTitle} Jobs in UK – FetchJobs`}
        metaDescription={`Find the best remote ${capitalizedJobTitle} jobs in the UK on FetchJobs. Explore verified work-from-home opportunities and apply now for high-paying remote roles.`}
      />
    </div>
  );
};

export default UkJobsByTitle;